export default "__VITE_ASSET__BV0rtjqs__"